// components
import Label from './label'

// types
import { BaseFieldProps } from '../field'

export type TextareaProps = {
	readonly type: 'textarea'
} & BaseFieldProps &
	React.TextareaHTMLAttributes<HTMLTextAreaElement>

const Textarea = (props: TextareaProps): JSX.Element => {
	const { label, ...attr } = props
	return (
		<>
			<label>
				<Label label={label} required={attr.required} />
				<textarea {...attr} rows={attr.rows ? attr.rows : 10} />
			</label>
		</>
	)
}

export default Textarea
